import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import Mask from '../mask';
import Swiper from '../swiper';
import SwiperItem from '../swiper-item';
const Preview = ({ defaultCurrent, urls, onClose }) => {
    const [current, setCurrent] = useState(() => {
        if (defaultCurrent) {
            const index = urls.indexOf(defaultCurrent);
            return index !== -1 ? index : 0;
        }
        return 0;
    });
    return (_jsxs(Mask, Object.assign({ onClick: onClose }, { children: [_jsx(Swiper, Object.assign({ className: 'taro-preview_swiper', current: current, onChange: event => {
                    setCurrent(event.detail.current);
                } }, { children: urls.map((url, index) => (_jsx(SwiperItem, Object.assign({ className: 'taro-preview_swiper-item' }, { children: _jsx("img", { className: 'taro-preview_img', src: url }) }), `${index}_${url}`))) })), _jsxs("div", Object.assign({ className: 'taro-preview_pagination' }, { children: [current + 1, "/", urls.length] }))] })));
};
export default Preview;
